import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Auto-redirect to /login when any authenticated request returns 401.
// Skips: the auth/me probe (handled silently by AuthProvider) and the
// public RSVP endpoints (intentionally unauthenticated).
let _redirecting = false;
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        const isAuthMe = url.includes("/auth/me");
        const isPublic = url.includes("/public/");
        const onLoginPage =
            typeof window !== "undefined" && window.location.pathname.startsWith("/login");

        if (status === 401 && !isAuthMe && !isPublic && !onLoginPage && !_redirecting) {
            _redirecting = true;
            try {
                sessionStorage.setItem(
                    "auth_redirect_reason",
                    "Your session expired. Please sign in again.",
                );
            } catch { /* ignore storage errors */ }
            window.location.replace("/login");
        }
        return Promise.reject(error);
    },
);
